import { ca } from '@cian/analytics';

import { getAllProducs } from '../../../../utils/trackings';
import { IFavoriteEntity } from '../../../../types/results';

export function trackCreateFolder(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_collection',
    label: 'main_block',
    products,
  });
}
